export const defaultLocale = "en" as const;
export const locales = ["en", "tr", "ru"] as const;
export type Locale = (typeof locales)[number];

export const localeNames: Record<Locale, string> = {
  en: "English",
  tr: "Türkçe",
  ru: "Русский",
};

// Intl date/number formatting tag per UI locale. Kept here (not inlined at each
// call site) so adding a locale never leaves a screen silently formatting dates
// in English while the rest of the page is translated.
export const intlLocales: Record<Locale, string> = {
  en: "en-US",
  tr: "tr-TR",
  ru: "ru-RU",
};

export function intlLocale(raw: string | null | undefined): string {
  return intlLocales[raw as Locale] ?? intlLocales.en;
}
